export const routes = [
  {
    path: '/usuario/atualizar-senha',
    component: () => import(/* webpackChunkName: "user" */ './components/ChangePassword'),
    name: 'update.password',
    props: true
  },

  {
    path: '/usuario',
    component: () => import(/* webpackChunkName: "user" */ './components/List'),
    name: 'user.list'
  },
  {
    path: '/usuario/novo',
    component: () => import(/* webpackChunkName: "user" */ './components/Insert'),
    name: 'user.insert'
  },
  {
    path: '/usuario/editar/:id',
    component: () => import(/* webpackChunkName: "user" */ './components/Get'),
    name: 'user.get',
    props: true
  }
]
